import { u } from "../lib/images";

export const site = {
  name: "The PilCoo Foundation",
  shortName: "PilCoo",
  tagline: "Small acts. Connected well. Meaningful change.",
  belief:
    "Because The PilCoo Foundation existed, no act of kindness was too small to matter.",
  email: "hello@thepilcoofoundation.org",
  city: "Bengaluru, India",
  disclaimer:
    "The PilCoo Foundation is a compassion-led community initiative. We do not claim charitable registration, tax-exemption status, or institutional certifications. Transparency pages will be published as formal milestones are reached.",
};

export const navLinks = [
  { label: "About", to: "/about" },
  { label: "Animals", to: "/animals" },
  { label: "People", to: "/people" },
  { label: "Nature", to: "/nature" },
  { label: "Activities", to: "/activities" },
  { label: "Events", to: "/events" },
  { label: "Stories", to: "/stories" },
  { label: "Our Impact", to: "/impact" },
];

export const socials = [
  { label: "Instagram", href: "https://www.instagram.com/thepilcoofoundation?utm_source=qr", key: "instagram" },
  { label: "X (Twitter)", href: "#", key: "x" },
  { label: "LinkedIn", href: "#", key: "linkedin" },
  { label: "YouTube", href: "#", key: "youtube" },
];

export const pacerClub = {
  url: "https://www.mypacer.com/clubs/4wo25y6v/the-pilcoo-foundation-bengaluru-karnataka?invitor=23y3vx85&short_id=729pCq1",
  label: "Join our Pacer Community",
};

export const whatsappChannel = {
  url: "https://whatsapp.com/channel/0029Vb8uzYTCMY0PTjbPWj3A",
  label: "Follow our WhatsApp Channel",
};

export const involveOptions = [
  {
    key: "volunteer",
    icon: "HandHeart",
    title: "Give your time",
    text: "Volunteer for an activity, or lend an organisation an extra pair of hands where it genuinely helps.",
    cta: "Volunteer with PilCoo",
    accent: "animals",
    action: { type: "form", enquiry: "volunteer" },
  },
  {
    key: "join",
    icon: "Footprints",
    title: "Join an activity",
    text: "Walk, participate, attend — or bring someone along. Showing up is itself a contribution.",
    cta: "Explore Activities",
    accent: "nature",
    action: { type: "link", to: "/activities" },
  },
  {
    key: "support",
    icon: "HeartHandshake",
    title: "Support a cause",
    text: "Contribute toward a specific, verified need identified with the community — never a black box.",
    cta: "See ways to help",
    accent: "people",
    action: { type: "form", enquiry: "cause" },
  },
  {
    key: "partner",
    icon: "Network",
    title: "Partner with PilCoo",
    text: "Shelters, veterinarians, counsellors, community groups and organisations can collaborate with us.",
    cta: "Partner with us",
    accent: "animals",
    action: { type: "form", enquiry: "collaborate" },
  },
  {
    key: "need",
    icon: "Megaphone",
    title: "Tell us about a need",
    text: "Know a genuine situation where the community may be able to help? Help us find it.",
    cta: "Tell us what's needed",
    accent: "people",
    action: { type: "form", enquiry: "cause" },
  },
  {
    key: "spread",
    icon: "Share2",
    title: "Spread the word",
    text: "Sometimes connecting the right people can itself make the difference. Tell someone about PilCoo.",
    cta: "Help spread the word",
    accent: "nature",
    action: { type: "share" },
  },
];

export const marqueeItems = [
  "Small acts",
  "Connected well",
  "Meaningful change",
  "Animals",
  "People",
  "Nature",
];

export const images = {
  heroMain: "/photos/home-hero-main.webp",
  heroSecondary: "/photos/home-hero-inset.webp",
  about: "/photos/about-main.webp",
  impact: "/photos/impact-bg.webp",
  involve: "/photos/get-involved.webp",
};
